import { css } from 'aphrodite';
import * as React from 'react';
import { styleSheet } from './styles';

export const LeadViewTableContainer: React.FC<React.PropsWithChildren> = props => {
	const { children } = props;
	return <div className={`${css(styleSheet.container)} lead-view-table-container`}>{children}</div>;
};
